import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'ml-table-paginator',
  template: `
    <mat-paginator
      [length]="count"
      [pageSizeOptions]="[25, 50, 100, 500]"
      [pageSize]="100"
      (page)="onChangePage($event)"
    ></mat-paginator>
  `,
  styleUrls: ['./table-paginator.component.scss']
})
export class TablePaginatorComponent implements OnInit {
  @Input() count: number;
  @Output() page = new EventEmitter<PageEvent>();

  constructor() {}

  ngOnInit() {}

  onChangePage(pageEvent: PageEvent) {
    this.page.emit(pageEvent);
  }
}
